import React, { useEffect, useState } from "react";

const MIN_SHOW_MS = 900; // avoid a flash when the menu loads instantly
const MAX_SHOW_MS = 8000; // never block the page if loading hangs
const FADE_MS = 500;

// Full-screen splash (cover art or logo), shown while the home page loads
function CoverSplash({ art, name, ready, onHidden }) {
  const [minTimeUp, setMinTimeUp] = useState(false);
  const [timedOut, setTimedOut] = useState(false);
  const leaving = (ready && minTimeUp) || timedOut;

  useEffect(() => {
    const min = setTimeout(() => setMinTimeUp(true), MIN_SHOW_MS);
    const max = setTimeout(() => setTimedOut(true), MAX_SHOW_MS);
    return () => {
      clearTimeout(min);
      clearTimeout(max);
    };
  }, []);

  useEffect(() => {
    if (!leaving) return;
    const t = setTimeout(onHidden, FADE_MS);
    return () => clearTimeout(t);
  }, [leaving, onHidden]);

  return (
    <div
      role="status"
      aria-label="Loading menu"
      className={`fixed inset-0 z-[10000] flex flex-col items-center justify-center gap-8 px-4 transition-opacity duration-500 bg-brand-500 ${leaving ? "opacity-0 pointer-events-none" : "opacity-100"}`}
    >
      {name && (
        <h1 className="text-4xl sm:text-6xl font-heading font-bold text-center leading-tight text-page">
          {name}
        </h1>
      )}
      <img
        src={art.src}
        alt=""
        className={`h-auto select-none ${art.isLogo ? "w-[min(200px,50vw)] rounded-2xl bg-white p-4 shadow-xl" : "w-[min(520px,88vw)]"}`}
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />
      <div className="w-10 h-10 rounded-full border-[3px] border-brand-200/25 border-t-brand-200 animate-spin" />
    </div>
  );
}

export default CoverSplash;
